import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { SettingsContext } from '../../../contexts';
import {
  STATUS_AVAILABLE,
  STATUS_PENDING_PAYMENT,
  STATUS_DEPOSIT_CREATED,
  STATUS_DEPOSIT_PAID,
} from '../../../order/constants';
import { Visible } from '../../../core/components';
import { Money } from '../../../components';

const ClientActions = ({ order, item, open, last }) => {
  const settings = useContext(SettingsContext);
  const history = useHistory()
  const topBorderClass = order.items.length > 1 && open ? 'top-border' : '';
  const invoiceAvailable = ![
    STATUS_AVAILABLE,
    STATUS_PENDING_PAYMENT,
    STATUS_DEPOSIT_CREATED,
    STATUS_DEPOSIT_PAID,
  ].includes(order.status);

  const paidAmount = (order?.payment?.amount || 0) + order?.items?.reduce((allSum, item) => {
    return allSum + item?.deposits?.reduce((sum, deposit) => sum + (deposit.amount || 0), 0);
  }, 0);
  const shouldFinalizePayment = paidAmount < order.total_amount;

  return (
    <div className={`col-last item-col ${topBorderClass}`}>
      <div className="position-bottom">
        <Visible when={shouldFinalizePayment && last}>
          <button onClick={() => history.push(`/checkout/${order.id}?${settings.iframeQueryParams}`)} className="mb-3">
            Finalize payment
          </button>
        </Visible>

        <Visible when={last}>
          <div className="amount">
            <Money amount={order.total_amount} currency={order.currency} />
          </div>
        </Visible>

        <Visible when={invoiceAvailable}>
          <div className="download-invoice">
            Download invoice
          </div>
        </Visible>

        <Visible when={order.status === STATUS_PENDING_PAYMENT}>
          <div className="goto-payment-btn">
            <Link to={`/order-payment/${order.reference_number}`}>
              <button>Go To Payment</button>
            </Link>
          </div>
        </Visible>
      </div>
    </div>
  );
};

export default ClientActions;
